import React, { useCallback, useMemo } from "react"

import { JsonCodeEditor } from "@/components/JsonCodeEditor"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"
import {
  JSON_TEMPLATE_FIELDS,
  validateJsonTemplate,
} from "@/utils/validation/jsonTemplateValidation"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import { DEFAULT_DTMF_TEMPLATE, type WebSocketFieldProps } from "./types"

export const DtmfFormatFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const dtmfTemplateError = useMemo(
    () =>
      validateJsonTemplate(
        metadata.send_dtmf_template,
        JSON_TEMPLATE_FIELDS.dtmf,
      ),
    [metadata.send_dtmf_template],
  )

  const handleDtmfTemplateChange = useCallback(
    (value: string) => {
      onMetadataUpdate({ send_dtmf_template: value })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">DTMF Format</h4>

      <div className="space-y-2">
        <FieldLabel tooltip={WEBSOCKET_TOOLTIPS.sendDtmfTemplate}>
          DTMF Send Template
        </FieldLabel>
        <JsonCodeEditor
          hideGutters
          copyable
          ariaLabel="DTMF Send Template"
          placeholder={DEFAULT_DTMF_TEMPLATE}
          value={metadata.send_dtmf_template || ""}
          onChange={handleDtmfTemplateChange}
          rows={4}
          disabled={disabled}
          error={dtmfTemplateError}
        />
      </div>
    </div>
  )
}
